module.exports = __webpack_public_path__ + "img/dimsum-2.ab24fb7c.jpg";